const devLocal = {
  endpoints: {
    API_URL: 'https://gsbacktest-grupoomint.msappproxy.net/api'
  },
  showDevTools: true
}

const remoteDev = {
  endpoints: {
    API_URL: 'http://localhost:63868/api'
  },
  showDevTools: true
}

const remoteTest = {
  endpoints: {
    API_URL: 'https://gsbacktest-grupoomint.msappproxy.net/api'
  },
  showDevTools: true
}

const remotePreProd = {
  endpoints: {
    API_URL: 'http://guardiasmart.miportalclinicas.com.ar:446/api'
  },
  showDevTools: false
}

const remoteProd = {
  endpoints: {
    API_URL: 'https://guardiasmart.miportalclinicas.com.ar:8444/api'
  },
  showDevTools: false
}

const config =
  process.env.REACT_APP_STAGE === 'prod'
    ? remoteProd
    : process.env.REACT_APP_STAGE === 'preprod'
    ? remotePreProd
    : process.env.REACT_APP_STAGE === 'remotetest'
    ? remoteTest
    : process.env.REACT_APP_STAGE === 'remotedev'
    ? remoteDev
    : devLocal

export default {
  ...config
}
